




























































































import {Component, Mixins, Prop} from 'vue-property-decorator'
import {ListDashboardSchema} from '@/schema/resource/Dashboard/ListDashboardSchema'
import {MixinQueryRouter, Helper} from 'simpli-web-sdk'
import FaturamentoFilter from '@/components/filters/FaturamentoFilter.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import DashboardFilter from '@/components/filters/DashboardFilter.vue'
import {DashboardFilterCollection} from '@/model/filter/DashboardFilterCollection'
import {Dashboard} from '@/model/resource/Dashboard'
import moment from 'moment'

@Component({
  components: {DashboardFilter, FaturamentoFilter, FilterToggle},
})
export default class DashboardView extends Mixins(MixinQueryRouter) {
  @Prop({type: Boolean, default: false}) annually!: boolean

  schema = new ListDashboardSchema()
  collection = new DashboardFilterCollection()
  filterOpen = false
  date = ''

  monthsOrYears: string[] = []

  get items() {
    if (this.annually) {
      const header = {...this.schema.header}
      delete header.qtdResponsaveisUltimos30Dias
      return header
    }
    return this.schema.header
  }

  async created() {
    await this.lastGenerationDate()
    if (!this.annually) {
      this.monthsOrYears = moment.months()
      this.collection.ano = moment(this.date).year() || moment().year()
      this.monthsOrYears.push(this.$t('schema.ListDashboard.total') as string)
    }

    this.collection.annually = this.annually
    await this.query()

    this.manageAnnuallyHeader()
  }

  manageAnnuallyHeader() {
    if (this.annually) {
      this.monthsOrYears = this.collection
        .all()
        .filter(it => it.month && it.month > 0)
        .map(it => String(it.month || 0))

      if (this.monthsOrYears.length < 12) {
        const [first] = this.monthsOrYears
        const missing = 12 - this.monthsOrYears.length
        let count = 0
        while (count < missing) {
          this.monthsOrYears.unshift(
            ((Number(first) - (count + 1)) as unknown) as string
          )
          count++
        }
      }

      this.monthsOrYears.push(this.$t('schema.ListDashboard.total') as string)
    }
  }

  get tableData() {
    const table = Array.from({length: 13}, () => new Dashboard())

    this.collection.all().forEach(item => {
      if (item.month && item.month > 0) {
        if (this.annually) {
          const index = this.monthsOrYears.findIndex(
            it => Number(it) === item.month
          )
          table[index] = item
        } else {
          table[item.month - 1] = item
        }
      } else {
        // Last value of array will be the Total (Sum of every month)
        table[this.monthsOrYears.length - 1] = item
      }
    })
    return table
  }

  async lastGenerationDate() {
    await this.$await.run('getLastUpdate', async () => {
      this.date = Helper.datetime(await Dashboard.getLastGenerationDate())
    })
  }
}
